jQuery(document).ready(function ($) {
    $(".couponlink").click(function () {
        $("#popupwrapper").addClass("visible");
    });
    $(".popupclose").click(function () {
        $("#popupwrapper").removeClass("visible");
    });
});
